import { useFormikContext } from 'formik';
import { useEffect } from 'react';

const useScrollToFormikError = () => {
  const { isSubmitting, errors } = useFormikContext();
  const errorNames = Object.keys(errors);

  useEffect(() => {
    if (isSubmitting && errorNames.length > 0) {
      const errorName = errorNames.find(error => document.querySelector(`[name=${error}]`));

      if (errorName) {
        const errorElement = document.querySelector(`[name=${errorName}]`);
        errorElement.scrollIntoView({ behavior: 'smooth', block: 'center' });
        errorElement.focus({ preventScroll: true });
      }
    }
  }, [errors, isSubmitting]);
};

export default useScrollToFormikError;
